import { render, staticRenderFns } from "./monthlyCarRenewalRecord.vue?vue&type=template&id=0d31e24e&scoped=true&"
import script from "./monthlyCarRenewalRecord.vue?vue&type=script&lang=js&"
export * from "./monthlyCarRenewalRecord.vue?vue&type=script&lang=js&"
import style0 from "./monthlyCarRenewalRecord.vue?vue&type=style&index=0&id=0d31e24e&scoped=true&lang=css&"
import style1 from "./monthlyCarRenewalRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d31e24e",
  null
  
)

export default component.exports